import { render, staticRenderFns } from "./Vtoggle.vue?vue&type=template&id=1262542d&scoped=true&"
import script from "./Vtoggle.vue?vue&type=script&lang=js&"
export * from "./Vtoggle.vue?vue&type=script&lang=js&"
import style0 from "./Vtoggle.vue?vue&type=style&index=0&id=1262542d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1262542d",
  null
  
)

export default component.exports